import httpUserClient from '@/plugins/httpUserClient';
import httpClient from '@/plugins/httpClient';

export default {
  login(data) {
    return httpUserClient.post('user/session', { user: { ...data } });
  },
  signIn(data) {
    return httpUserClient.post('user/registration', { user: { ...data } });
  },
  logout() {
    return httpUserClient.delete('user/session');
  },
  getCode(data) {
    return httpUserClient.post('sms_codes', { sms_code: { ...data } });
  },
  reset(data) {
    return httpClient.post('user/password', { user: { ...data } });
  },
};



// WEBPACK FOOTER //
// ./src/apiSet/userAuth.js